import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@/components/ui/tabs";
import { Loader2, Save, Plus, Trash2, RotateCcw, FileSignature } from "lucide-react";
import { toast } from "sonner";

export function ContratoModelosConfig() {
  const [d, setD] = useState(null);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/settings/contrato-modelos").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return <Loader2 className="w-6 h-6 animate-spin gold-text" />;
  const setM = (k, patch) => setD((p) => ({ ...p, modelos: { ...p.modelos, [k]: { ...p.modelos[k], ...patch } } }));
  const setCl = (k, i, patch) => setM(k, { clausulas: d.modelos[k].clausulas.map((c, j) => (j === i ? { ...c, ...patch } : c)) });
  const save = async () => {
    setSaving(true);
    try {
      await api.put("/settings/contrato-modelos", { modelos: Object.fromEntries(Object.entries(d.modelos).map(([k, m]) => [k, { titulo: m.titulo, clausulas: m.clausulas }])) });
      toast.success("Modelos de contrato salvos!");
    } catch (e) { toast.error(e.response?.data?.detail || "Erro ao salvar"); } finally { setSaving(false); }
  };
  return (
    <div className="space-y-4" data-testid="contrato-modelos-config">
      <div className="trt-card p-5">
        <h3 className="font-bold flex items-center gap-2"><FileSignature className="w-5 h-5 gold-text" /> Modelos de contrato (cláusulas)</h3>
        <p className="text-xs text-slate-500 mt-1">Cada modelo tem título e cláusulas próprias. Variáveis: {d.variaveis.map((v) => <code key={v} className="bg-slate-100 px-1 rounded mr-1">{`{{${v}}}`}</code>)}</p>
        <p className="text-xs text-slate-500 mt-1">A cláusula que contém “GARANTIA” só entra no PDF quando o contrato tiver Garantia = Sim.</p>
        <Tabs defaultValue="padrao" className="mt-3">
          <TabsList>{Object.entries(d.modelos).map(([k, m]) => <TabsTrigger key={k} value={k} data-testid={`modelo-tab-${k}`}>{m.nome}</TabsTrigger>)}</TabsList>
          {Object.entries(d.modelos).map(([k, m]) => (
            <TabsContent key={k} value={k} className="space-y-3 mt-3">
              <div><Label className="text-xs">Título do contrato</Label><Input value={m.titulo} onChange={(e) => setM(k, { titulo: e.target.value })} className="mt-1" data-testid={`modelo-titulo-${k}`} /></div>
              {m.clausulas.map((c, i) => (
                <div key={i} className="border rounded-lg p-3 space-y-2" data-testid={`clausula-${k}-${i}`}>
                  <div className="flex gap-2 items-center">
                    <Input value={c.titulo} onChange={(e) => setCl(k, i, { titulo: e.target.value })} className="font-semibold" placeholder="Título da cláusula" />
                    <Button size="icon" variant="ghost" onClick={() => setM(k, { clausulas: m.clausulas.filter((_, j) => j !== i) })} className="text-red-600 shrink-0" data-testid={`clausula-del-${k}-${i}`}><Trash2 className="w-4 h-4" /></Button>
                  </div>
                  <Textarea value={c.texto} onChange={(e) => setCl(k, i, { texto: e.target.value })} rows={3} className="text-sm" />
                </div>
              ))}
              <div className="flex gap-2 flex-wrap">
                <Button variant="outline" size="sm" onClick={() => setM(k, { clausulas: [...m.clausulas, { titulo: "NOVA CLÁUSULA", texto: "" }] })} className="gap-1" data-testid={`clausula-add-${k}`}><Plus className="w-4 h-4" /> Adicionar cláusula</Button>
                <Button variant="ghost" size="sm" onClick={() => setM(k, { titulo: m.padrao.titulo, clausulas: m.padrao.clausulas })} className="gap-1" data-testid={`modelo-restaurar-${k}`}><RotateCcw className="w-4 h-4" /> Restaurar padrão</Button>
              </div>
            </TabsContent>
          ))}
        </Tabs>
        <Button onClick={save} disabled={saving} className="mt-4 bg-onyx hover:bg-black text-white gap-2" data-testid="modelos-save-btn">{saving ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Save className="w-4 h-4" /> Salvar modelos</>}</Button>
      </div>
    </div>
  );
}
